import { formatDateDDMMYY } from '@helper/utils';
import { ReactElement, useCallback } from 'react';
import { MDPMeetingObject } from './index';
import { NavLink } from 'react-router-dom';
import { useNonAttendedMembersStore } from '@store/nonAttendedMembersStore';
import { useGetRxDb } from '@hooks/getRxdbData';
import { ProfileData } from '@services/hooks/profile';
import { useUserRoleType } from '@hooks/useUserRoleType';

export const MdpMeetingCard = (props: { data: MDPMeetingObject }): ReactElement => {
	const {
		meeting_type_c,
		name,
		createddate,
		id,
		cmditownlist_c,
		participantspermeeting_c,
		plan_budget_c,
		monthname_c,
		number_of_planned_meetings_c,
		actual_number_of_planned_meetings_c,
		financial_year_c,
	} = props.data;
	const { result: profile } = useGetRxDb<ProfileData>('profile');
	const { resetMembersStore } = useNonAttendedMembersStore();
	const budget = plan_budget_c ? parseFloat(plan_budget_c).toFixed() : 0;
	const userRole = useUserRoleType();
	const status =
		number_of_planned_meetings_c && actual_number_of_planned_meetings_c
			? 'Planned'
			: number_of_planned_meetings_c != null
				? 'Assigned'
				: '';

	const getMeetingStatus = useCallback((name: string | null) => {
		switch (name) {
			case 'Planned':
				return 'meeting-completed';
			case 'Assigned':
				return 'today-meeting';
			default:
				return '';
		}
	}, []);

	return (
		<li className="d-col d-col-2">
			<NavLink
				to={(userRole === 'BDE' || userRole === 'KAE') && status == 'Assigned' ? '/edit-meeting' : null}
				aria-label="add meeting"
				className={`meeting-module-card ${userRole === 'RBDM' || status === 'Planned' ? 'disabled' : ''}`}
				state={{ id: id, type: 'MDP' }}
				onClick={() => resetMembersStore()}
			>
				<div className="meeting-upper-details">
					<div className="left-content">
						<span className="meeting-id">{name ?? `FV-${profile[0]?.mdicode_c}`}</span>
					</div>
					<div className="date-details">
						<span className="date">{createddate ? formatDateDDMMYY(new Date(createddate)) : '--'}</span>
					</div>
				</div>

				<div className="meeting-info">
					<p className="club">{cmditownlist_c}</p>
					<p className="club">
						{monthname_c} {financial_year_c}
					</p>
				</div>
				<div className="meeting-info">
					<p className="club">Budget: ₹{budget}</p>
					<p className="club">Participants: {participantspermeeting_c}</p>
				</div>

				<div className="meeting-bottom-wrapper">
					{meeting_type_c && (
						<div className="meeting-bottom-details top-content">
							<span className="meeting-about h4">{meeting_type_c ?? '-'}</span>
						</div>
					)}

					<div className="meeting-bottom-details">
						<span className={`meeting-status ${getMeetingStatus(status)}`}>{status}</span>
					</div>
				</div>
			</NavLink>
		</li>
	);
};
